document.addEventListener("DOMContentLoaded", () => {
    let desc = document.querySelector('.enable_truncate');
    if (desc) {
        let fDescTitleHeight = desc.querySelector('.enable_truncate-title').offsetHeight;
        let originalHeight = desc.offsetHeight;
        desc.style.maxHeight = Number(fDescTitleHeight) + "px";
        let truncateBtn = document.querySelector('.enable_truncate-button');
        truncateBtn.addEventListener('click', () => {
            if (truncateBtn.classList.contains('open')) {
                desc.style.maxHeight = Number(fDescTitleHeight) + "px";
                truncateBtn.classList.remove('open');
                truncateBtn.innerHTML = "Read more";
            } else {
                desc.style.maxHeight = Number(originalHeight) + "px";
                truncateBtn.classList.add('open');
                truncateBtn.innerHTML = "Read less";
            }
        })
    }
})